<template>
  <div class="page-container">
    <div class="main">
      <page :url="url" :form="form" @reset="reset">
        <template slot="tableSearch">

          <el-form-item v-if="ROLE_TYPE.isManager()"
                        :label="$t('text.agent')">
            <el-select v-model="form.agentId"
                       filterable
                       clearable
                       :placeholder="$t('message.chooseOne')"
                       popper-class="eloption">
              <el-option v-for="item in agentList"
                         :key="item.agentId"
                         :label="item.agentId + '-' + item.agentName"
                         :value="item.agentId"/>
            </el-select>
          </el-form-item>

          <el-form-item v-if="ROLE_TYPE.isManager() || ROLE_TYPE.isAgent()"
                        :label="$t('text.merchantName')">
            <el-select v-model="form.appId"
                       filterable
                       clearable
                       :placeholder="$t('message.chooseOne')"
                       popper-class="eloption">
              <el-option :label="$t('option.all')"
                         value=""/>
              <el-option v-for="merchant in merchantList"
                         :label="merchant.value + '-' + merchant.name"
                         :key="merchant.value"
                         :value="merchant.value"/>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('text.settlementCycle')">
            <el-select v-model="setSettlementCycleList" multiple>
              <el-option :label="$t('option.all')"
                         value="all"></el-option>
              <el-option :label="$t('settlementCycle.D0')"
                         value="D0"></el-option>
              <el-option :label="$t('settlementCycle.T1')"
                         value="T1"></el-option>
              <el-option :label="$t('settlementCycle.D0T1')"
                         value="D0T1"></el-option>
              <el-option :label="$t('settlementCycle.T2')"
                         value="T2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('text.date')">
            <el-date-picker v-model="timeDate"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyyMMdd"
                            :range-separator="$t('text.to')"
                            :start-placeholder="$t('text.startDate')"
                            :end-placeholder="$t('text.endDate')"
                            @change="timeChange">
            </el-date-picker>
          </el-form-item>
        </template>
        <template slot="buttonArea">
          <el-button :loading="loading"
                     :disabled="exporting"
                     type="primary"
                     @click="exportDetail"
                     size="small">
            {{ $t('text.export') }}
          </el-button>
        </template>
        <template slot="tableColumn">
          <el-table-column width="150px"
                           prop="merchantName"
                           v-if="ROLE_TYPE.isManager()"
                           :label="$t('text.merchantName')"
                           fixed
                           align="center"/>
          <el-table-column width="120px"
                           prop="bdName"
                           v-if="ROLE_TYPE.isManager()"
                           :label="$t('text.bdName')"
                           align="center"/>

          <el-table-column width="130px"
                           prop="balance"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.balance')"
                           sortable
                           :sort-method="(a, b) => Number(a.balance) - Number(b.balance)"
                           align="center"/>

          <el-table-column width="100"
                           prop="statisticsDate"
                           :label="$t('text.date')"
                           :formatter="$formatter.formatDate"
                           align="center"/>
          <el-table-column width="170"
                           prop="updateTime"
                           :label="$t('text.updateTime')"
                           align="center"/>
          <el-table-column prop="agentName"
                           v-if="ROLE_TYPE.isManager()"
                           width="120px"
                           :label="$t('text.agentName')"
                           align="center"/>
          <el-table-column prop="agentFee"
                           v-if="ROLE_TYPE.isManager()"
                           :formatter="$formatter.FenToYuanToThousandth"
                           width="120px"
                           :label="$t('text.merchantAgentFee')"
                           align="center"/>
          <el-table-column prop="channelAgentFee"
                           v-if="ROLE_TYPE.isManager()"
                           :formatter="$formatter.FenToYuanToThousandth"
                           width="120px"
                           :label="$t('text.channelAgentFee')"
                           align="center"/>
          <el-table-column width="180px"
                           v-if="ROLE_TYPE.isManager()"
                           prop="appId"
                           :label="$t('text.appId')"
                           align="center"/>

          <el-table-column prop="" v-if="ROLE_TYPE.isManager()" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column v-for="(value, key) in PaymentType[this.country].PAYMENT"
                           width="120px"
                           prop="paymentRateConfig"
                           :label="$t(`text.collection${key}FeeRate`)"
                           align="center" >
            <template slot-scope="scope">
              {{ JSON.parse(scope.row.paymentRateConfig || '{}')[value] || '' }}
            </template>
          </el-table-column>

          <el-table-column width="120px"
                           prop="paymentAmount"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.collectionAmount')"
                           sortable
                           :sort-method="paymentAmountSortMethod"
                           align="center"/>
          <el-table-column width="120px"
                           prop="paymentCost"
                           v-if="showUpstreamCostColumns"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.collectionCost')"
                           sortable
                           :sort-method="paymentCostSortMethod"
                           align="center"/>
          <el-table-column width="120px"
                           prop="paymentEPAmount"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.collectionEPAmount')"
                           sortable
                           :sort-method="paymentEPAmountSortMethod"
                           align="center"
                           v-if="this.$store.state.isPK"/>
          <el-table-column width="120px"
                           prop="paymentJCAmount"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.collectionJCAmount')"
                           sortable
                           :sort-method="paymentJCAmountSortMethod"
                           align="center"
                           v-if="this.$store.state.isPK"/>
          <el-table-column width="120px"
                           prop="paymentFee"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.collectionFee')"
                           align="center"/>
          <el-table-column width="80px"
                           prop="paymentCount"
                           :label="$t('text.collectionCount')"
                           align="center"/>
          <el-table-column width="120px"
                           prop="paymentEasypaisaCountSuccess"
                           :label="$t('text.collectionEPSuccessCount')"
                           align="center"
                           v-if="this.$store.state.isPK"/>
          <el-table-column width="120px"
                           prop="paymentJazzcashCountSuccess"
                           :label="$t('text.collectionJCSuccessCount')"
                           align="center"
                           v-if="this.$store.state.isPK"/>
          <el-table-column width="90px"
                           prop="paymentCountSuccess"
                           :label="$t('text.collectionSuccessCount')"
                           align="center"/>
          <el-table-column width="150px"
                           prop="paymentCountSuccessRate"
                           :label="$t('text.collectionSuccessRateMerchant')"
                           sortable
                           align="center"/>
          <el-table-column width="90px"
                           prop="paymentCountFailed"
                           :label="$t('text.collectionFailedCount')"
                           align="center"/>
          <el-table-column width="120px"
                           prop="paymentEasypaisaCountRealSuccessRate"
                           :label="$t('text.collectionEPRealSuccessRateChannel')"
                           sortable
                           align="center"
                           v-if="this.$store.state.isPK"/>
          <el-table-column width="120px"
                           prop="paymentJazzcashCountRealSuccessRate"
                           :label="$t('text.collectionJCRealSuccessRateChannel')"
                           sortable
                           align="center"
                           v-if="this.$store.state.isPK"/>
          <el-table-column width="150px"
                           prop="paymentCountRealSuccessRate"
                           :label="$t('text.collectionRealSuccessRateChannel')"
                           sortable
                           align="center"/>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column v-for="(value, key) in PaymentType[this.country].TRANSFER"
                           width="120px"
                           prop="transferRateConfig"
                           :label="$t(`text.disbursement${key}FeeRate`)"
                           align="center">
            <template slot-scope="scope">
              {{ JSON.parse(scope.row.transferRateConfig || '{}')[value] || '' }}
            </template>
          </el-table-column>

          <el-table-column width="120px"
                           prop="transferAmount"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.disbursementAmount')"
                           sortable
                           :sort-method="transferAmountSortMethod"
                           align="center"/>
          <el-table-column width="120px"
                           prop="transferCost"
                           v-if="showUpstreamCostColumns"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.disbursementCost')"
                           sortable
                           :sort-method="transferCostSortMethod"
                           align="center"/>
          <el-table-column width="120px"
                           prop="transferFee"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.disbursementFee')"
                           align="center"/>
          <el-table-column prop="transferAgentFee"
                           width="120px"
                           :formatter="$formatter.FenToYuan3ToThousandth"
                           :label="$t('text.agentBalance')"
                           align="center"/>
          <el-table-column width="90px"
                           prop="transferCount"
                           :label="$t('text.disbursementCount')"
                           align="center"/>
          <el-table-column width="100px"
                           prop="transferEasypaisaCountSuccess"
                           :label="$t('text.disbursementEPSuccessCount')"
                           align="center"
                           v-if="this.$store.state.isPK"/>
          <el-table-column width="90px"
                           prop="transferJazzcashCountSuccess"
                           :label="$t('text.disbursementJCSuccessCount')"
                           align="center"
                           v-if="this.$store.state.isPK"/>
          <el-table-column width="90px"
                           prop="transferCountSuccess"
                           :label="$t('text.disbursementSuccessCount')"
                           align="center"/>
          <el-table-column width="150px"
                           prop="transferCountSuccessRate"
                           :label="$t('text.disbursementSuccessRateMerchant')"
                           sortable
                           align="center"/>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column width="100px"
                           prop="transferCountFailed"
                           :label="$t('text.disbursementFailedCount')"
                           align="center"/>
          <el-table-column width="120px"
                           prop="transferEasypaisaCountRealSuccessRate"
                           :label="$t('text.disbursementEPRealSuccessRateChannel')"
                           sortable
                           align="center"
                           v-if="this.$store.state.isPK"/>
          <el-table-column width="120px"
                           prop="transferJazzcashCountRealSuccessRate"
                           :label="$t('text.disbursementJCRealSuccessRateChannel')"
                           sortable
                           align="center"
                           v-if="this.$store.state.isPK"/>
          <el-table-column width="145px"
                           prop="transferCountRealSuccessRate"
                           :label="$t('text.disbursementRealSuccessRateChannel')"
                           sortable
                           align="center"/>
          <el-table-column width="120px"
                           prop="depositAmount"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.rechargeAmount')"
                           align="center"/>
          <el-table-column width="120px"
                           prop="withdrawAmount"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.withdrawalAmount')"
                           align="center"/>

          <el-table-column width="120px"
                           prop="settledAmount"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.settledAmount')"
                           align="center"/>

          <el-table-column prop="settlementCycle" width="140px" :label="$t('text.settlementCycle')" align="center"/>

          <el-table-column width="150px"
                           prop="settleStartTime"
                           :label="$t('text.settleStartTime')"
                           align="center"/>

          <el-table-column width="150px"
                           prop="settleEndTime"
                           :label="$t('text.settleEndTime')"
                           align="center"/>

          <el-table-column width="100px"
                           prop="unsubmittedTime"
                           :label="$t('text.unsubmittedTime')"
                           align="center"/>
        </template>
      </page>
    </div>
  </div>
</template>
<script>
import Page from "@/components/Page.vue";
import moment from "moment";
import {ROLE_TYPE} from "@/utils/Constant";
import { PaymentType } from '@/constants/paymentTypes';

export default {
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE
    },
    /** 成本栏位：商户相关角色不展示 */
    showUpstreamCostColumns() {
      return !ROLE_TYPE.isMerchantRelated();
    },
    setSettlementCycleList: {
      get() {
        return this.form.settlementCycleList ? this.form.settlementCycleList.split(',') : [];
      },
      set(value) {
        this.form.settlementCycleList = value.join(',');
      }
    }
  },
  components: {
    page: Page,
  },
  data() {
    return {
      url: "/statistics-merchant/listStatisticsMerchant",
      merchantList: [],
      agentList: [],
      loading: false,
      exporting: false,
      country: this.$store.state.isPK ? 'PK' : 'BD',
      form: {
        appId: "",
        startDate: "",
        endDate: "",
        tradeOrderId: "",
        settlementCycleList:"",
      },
      timeDate: [],
      PaymentType
    };
  },
  methods: {
    paymentAmountSortMethod(a, b) {
      const valA = a.paymentAmount ? parseFloat(a.paymentAmount.replace(/,/g, '')) : 0;
      const valB = b.paymentAmount ? parseFloat(b.paymentAmount.replace(/,/g, '')) : 0;
      return valB - valA;
    },
    paymentCostSortMethod(a, b) {
      const valA = a.paymentCost ? parseFloat(String(a.paymentCost).replace(/,/g, '')) : 0;
      const valB = b.paymentCost ? parseFloat(String(b.paymentCost).replace(/,/g, '')) : 0;
      return valB - valA;
    },
    paymentEPAmountSortMethod(a, b) {
      const valA = a.paymentEPAmount ? parseFloat(a.paymentEPAmount.replace(/,/g, '')) : 0;
      const valB = b.paymentEPAmount ? parseFloat(b.paymentEPAmount.replace(/,/g, '')) : 0;
      return valB - valA;
    },
    paymentJCAmountSortMethod(a, b) {
      const valA = a.paymentJCAmount ? parseFloat(a.paymentJCAmount.replace(/,/g, '')) : 0;
      const valB = b.paymentJCAmount ? parseFloat(b.paymentJCAmount.replace(/,/g, '')) : 0;
      return valB - valA;
    },
    transferAmountSortMethod(a, b) {
      const valA = a.transferAmount ? parseFloat(a.transferAmount.replace(/,/g, '')) : 0;
      const valB = b.transferAmount ? parseFloat(b.transferAmount.replace(/,/g, '')) : 0;
      return valB - valA;
    },
    transferCostSortMethod(a, b) {
      const valA = a.transferCost ? parseFloat(String(a.transferCost).replace(/,/g, '')) : 0;
      const valB = b.transferCost ? parseFloat(String(b.transferCost).replace(/,/g, '')) : 0;
      return valB - valA;
    },
    timeChange(e) {
      if (e) {
        this.form.startDate = e[0];
        this.form.endDate = e[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
    },
    reset() {
      let start = moment().subtract(7, 'days').format('yyyyMMDD');
      let end = moment().format('yyyyMMDD');
      this.form.startDate = start;
      this.form.endDate = end;
      this.timeDate = [start, end];
    },
    exportDetail() {
      this.loading = true;
      this.exporting = true;
      this.axios
          .get("/statistics-merchant/list-statistics-merchant/export", {
            params: this.form,
            responseType: "blob",
            timeout: 30 * 60 * 1000
          })
          .then((res) => {
            if (res.data) {
              // 回excel資料，瀏覽器下載
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", this.$t('text.merchantReportExport'));
              document.body.appendChild(link);
              link.click();
            } else if (res.text) {
              // 回JSON，開彈窗
              res.text()
                  .then(JSON.parse)
                  .then((res) => {
                    if (res.code !== 200) {
                      this.$message({
                        message: res.msg,
                        type: "error"
                      });
                    } else {
                      this.$message({
                        message: res.msg,
                        type: "success"
                      });
                    }
                  });
            }
            this.exporting = false;
          }).catch((error) => {
        console.log(error);
        this.$notify.error({
          title: this.$t('text.prompt'),
          message: this.$t('message.exportFailed')
        });
        this.exporting = false;
      });
      this.loading = false;
    },
  },

  created() {
    if (ROLE_TYPE.isManager()){
      this.$axios
          .get('/agent/selectAgentForOption', {params: {}})
          .then(res => {
            this.agentList = res.data
          })
    }

    if (ROLE_TYPE.isManager() || ROLE_TYPE.isAgent()){
      this.$axios
          .get("/merchant/selectListForOption", {params: {}})
          .then((res) => {
            this.merchantList = res.data;
            if (this.merchantList.length === 1) {
              this.form.appId = this.merchantList[0].value;
              this.$bus.$emit("refresh");
            }
          });
    }
  },
};
</script>
<style lang="scss" scoped>
.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.el-form-item {
  margin-bottom: 5px;
}
</style>
